<template>
    <div class="container" v-bind:class="{ 'welcome-not-authorized' : !isAuthorized }">
      <section class="section">
        <h1 class="title"> Добро пожаловать<span v-if="username">, {{ username }} </span> </h1>
        <h2 class="subtitle"> Вас приветствует система {{appname}} </h2>
        <br>
        <div v-if="!isAuthorized">
          <label class="label">Пожалуйста, войдите в свою учетную запись для начала работы</label>
          <div class="control">
            <el-col :span="3">
              <el-button class="button" type="info" v-on:click="signIn"><span>Войти</span></el-button>
            </el-col>
          </div>
        </div>
        <div v-if="isAuthorized">
            <p> Начните работу, используя меню слева </p>
        </div>
      </section>
    </div>
</template>

<script>
  import config from '../appsettings.js'
  export default {
    name: 'welcome',
    data() {
      return {
        username: '',
        appname: config.APP_NAME,
        isAuthorized: false
      }
    },
    methods: {
      signIn() {
        this.$manager.signinRedirect()
          .catch(function(err){
          console.log(err)
        })
      }
    },
    created() {
      this.$manager.getUser().then(user => {
        if (user) {
          this.isAuthorized = true;
          this.username = user.profile.given_name;
        } else {
          this.isAuthorized = false;
          this.username = '';
        }
      });
    }
  }
</script>

<style scoped>
  .welcome-not-authorized {
    margin-left: 20%;
    margin-top: 50px;
  }

  .button {
    display: inline-block;
    vertical-align:middle;
    border-radius: 4px;
    background-color: #50bfff;
    border: none;
    color: #FFFFFF;
    text-align: center;
    font-size: 20px;
    padding: 8px;
    width: 100%;
    transition: all 0.5s;
    cursor: pointer;
    margin: 5px;
  }

  .button span {
    cursor: pointer;
    display: inline-block;
    position: relative;
    transition: 0.5s;
  }

  .button span:after {
    content: '\00bb';
    position: absolute;
    opacity: 0;
    top: 0;
    right: -20px;
    transition: 0.5s;
  }

  .button:hover span {
    padding-right: 25px;
  }

  .button:hover span:after {
    opacity: 1;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/welcome.vue